export default {
  system: {
    user: 'Foydalanuvchi',
    level: 'Daraja',
    earnPerTap: 'Har bosishdan daromad',
    coinsToLevelUp: "Darajani ko'tarish uchun tangalar",
    profitPerHour: 'Soatlik daromad',
    coming1: 'Tez orada bu yerda',
    coming2: "qiziqarli narsa bo'ladi...",
    close: 'Yopish',
    friends: "Do'stlar",
    continue: 'Davom etish',
  },
  settings: {
    chooseNetwork: 'Tarmoqni tanlang',
    chooseLanguage: 'Tilni tanlang',
  },
  popup_CheckTask: {
    join: "Qo'shilish",
    check: 'Tekshirish',
    taskIsNotCompleted: 'Vazifa bajarilmadi',
  },
  popup_levelUp: {
    levelUp: "Daraja ko'tarildi!",
    multiTap: "Ko'p bosish",
    energyLimit: 'Energiya chegarasi',
  },
  popup_BalanceUp: {
    balanceUp: 'Balans yangilandi!',
    balanceDiffSinceLast: 'Sizning mukofotingiz',
  },
  popup_BalanceTip: {
    tip: 'Daromadingizni oshiring',
    message: 'Tarmoqni yaxshilash uchun Kon menyusini bosing',
    description: 'Oflayn rejimda ham 3 soatgacha ishlang',
  },
  popup_Bored: {
    header: 'Qurbaqa zerikdi!',
    message: "Qurbaqa bilan o'ynang.",
    description: "Agar qurbaqa bilan 3 soat o'ynamasangiz, daromad to'xtaydi",
  },
  popup_Hungry: {
    header: 'Qurbaqa och qoldi!',
    message: 'Qurbaqani oziqlantiring.',
    description: "Qancha ko'p do'stingiz bo'lsa, har bir ovqatlanishdan shuncha ko'p tanga olasiz",
  },
  menu: {
    network: 'Tarmoq',
    mine: 'Kon',
    earn: 'Ishlab topish',
    food: 'Oziq-ovqat',
  },
  tap: {
    bored: 'Zerikkan',
    fun: 'Qiziqarli',
  },
  mineMenu: {
    activities: 'Faoliyatlar',
    investments: 'Investitsiyalar',
    web3: 'WEB3',
    achievements: 'Yutuqlar',
  },
  mine: {
    joinOurTG1: "Bizning Telegram kanalimizga qo'shiling,",
    joinOurTG2: 'ochish uchun!',
    unlock: 'Ochish',
  },
  leaderboard: {
    from: 'dan',
    beTheFirst: "Birinchi bo'ling!",
  },
  friends: {
    inviteFriends: "Do'stlaringizni taklif qiling!",
    receiveBonuses: "Siz va do'stingiz bonuslar olasiz",
    inviteFriend: "Do'stni taklif qilish",
    withTelegramPremium: 'Telegram Premium bilan',
    forYouAndYourFriend: "siz va do'stingiz uchun",
    moreBonuses: "Ko'proq bonuslar",
    listOfYourFriends: "Do'stlaringiz ro'yxati",
    linkCopied: 'Taklif havolasi vaqtinchalik xotiraga nusxalandi!',
    playWithMe:
      "Menga qo'shiling va airdrop orqali tokenlar olish uchun o'ynang!\n" +
      "💰 Sovg'angizni oling! Yangi kelganlar uchun +3000 tanga\n" +
      '🚀 Telegram Premium bormi? +5000 tanga oling!\n',
  },
  earn: {
    moreCoins: "Ko'proq tanga ishlang!",
    dailyTasks: 'Kunlik vazifalar',
    dailyReward: 'Kunlik mukofot',
    tasksList: "Vazifalar ro'yxati",
    joinOurTG: "Bizning Telegram kanalimizga qo'shiling",
    followOurX: 'X hisobimizni kuzatib boring',
    yourAd: "Bu yerda sizning reklamangiz bo'lishi mumkin",
    connect: "Telegram kanalimiz admini bilan bog'laning",
  },
  food: {
    hungry: 'Och',
    full: "To'q",
    frogIsFull: "Qurbaqa to'q",
    feed: 'Oziqlantirish',
    bonus: 'Bonus',
    satiety: "To'qlik",
    hours: 'soat',
  },
  toast: {
    buyCard: {
      title: 'Yutuq ochildi!',
      subtitle: "Qurbaqa imperiyangizni ulug'likka olib borish vaqti keldi 👑",
    },
    feedFrog: {
      title: 'Qurbaqa xursand!',
      subtitle: 'Ajoyib ish! Jilmayishlarni davom ettirish uchun uy hayvoningizni oziqlantiring 🍽️',
    },
  },
};
